/**
 * Espelho do permission.registry.ts da API.
 * Sincronize esta lista ao adicionar/remover permissões no backend.
 */
export const PERMISSIONS = {
  // Role management
  ROLE_CREATE: 'role:create',
  ROLE_READ: 'role:read',
  ROLE_UPDATE: 'role:update',
  ROLE_DELETE: 'role:delete',

  // User management
  USER_CREATE: 'user:create',
  USER_LIST: 'user:list',
  USER_READ: 'user:read',
  USER_UPDATE: 'user:update',
  USER_ACTIVATE: 'user:activate',
  USER_DEACTIVATE: 'user:deactivate',
  USER_RESET_PASSWORD: 'user:reset-password',
  USER_IMPORT: 'user:import',

  // MFA
  MFA_RESET: 'mfa:reset',

  // Visit reports
  VISIT_REPORT_CREATE: 'visit-report:create',
  VISIT_REPORT_READ: 'visit-report:read',

  // Agenda
  AGENDA_READ: 'agenda:read',
  AGENDA_CREATE: 'agenda:create',
  AGENDA_IMPORT: 'agenda:import',
  AGENDA_CLOSE: 'agenda:close',
  AGENDA_CANCEL: 'agenda:cancel',
  AGENDA_RESCHEDULE: 'agenda:reschedule',
  AGENDA_CHECK_IN: 'agenda:check-in',
  AGENDA_UPLOAD_FILES: 'agenda:upload-files',
  AGENDA_GENERATE_INSIGHTS: 'agenda:generate-insights',
  AGENDA_DASHBOARD: 'agenda:dashboard',
  AGENDA_ANALYSIS_FEEDBACK_READ: 'agenda-analysis:feedback:read',

  // Audit
  AUDIT_READ: 'audit:read',

  // Parameters
  PARAMETERS_READ: 'parameters:read',

  // Accounts (contas gerenciais)
  ACCOUNT_LIST: 'account:list',
  ACCOUNT_LIST_BALANCES: 'account:list-balances',
  ACCOUNT_ANALYSIS_GROUP_LIST: 'account:analysis-group.list',
  ACCOUNT_CUSTOM_ACCOUNT_LIST: 'account:custom-account:list',
  ACCOUNT_CUSTOM_ACCOUNT_CREATE: 'account:custom-account:create',
  ACCOUNT_CUSTOM_ACCOUNT_TOGGLE: 'account:custom-account:toggle',
  ACCOUNT_CUSTOM_ACCOUNT_IMPORT_TEMPLATE: 'account:custom-account:import-template',
  ACCOUNT_CUSTOM_ACCOUNT_IMPORT: 'account:custom-account:import',

  // Agenda — associate blocks
  AGENDA_MANAGE_ASSOCIATE_BLOCKS: 'agenda:manage-associate-blocks',

  // Agenda — validation
  AGENDA_VALIDATE: 'agenda:validate',

  // Goals (metas gerenciais)
  GOAL_LIST: 'goal:list',
  GOAL_CREATE: 'goal:create',
  GOAL_UPDATE: 'goal:update',
  GOAL_DELETE: 'goal:delete',
  GOAL_DUPLICATE: 'goal:duplicate',
  GOAL_ITEM_MANAGE: 'goal:item:manage',
  GOAL_TRACK: 'goal:track',
  GOAL_ITEM_MANAGER_UNIT_OVERRIDE: 'goal:item:manager-unit-override',

  // Associate panel (painel 360º)
  ASSOCIATE_PANEL_READ: 'associate-panel:read',

  // Manager panel (painel do gerente)
  MANAGER_PANEL_READ: 'manager-panel:read',
} as const

export type Permission = (typeof PERMISSIONS)[keyof typeof PERMISSIONS]
